import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Popover } from "antd";
import { Form, Radio, notification, InputNumber } from "antd";
import { Col, Row } from "react-bootstrap";
import TextInput from "../../../common/UITextInput/TextInput";
import UiButton from "../../../common/UiButton/UiButton";
import UISectionHeading from "../../../common/UiDrawerHeading/UiDrawerHeading";
import "./style.css";
import { Input } from "antd";
import UiDropDown from "../../../common/UiDropDown/UiDropDown";
import { connect } from "react-redux";
import {
  bucketChange,
  getAddLeadMasterList,
  getBranchLocationByArea,
  getBranchLocationByPincode,
  getCourseTypeName,
  getPincodeOnSearch,
  getRelationshipDetails,
  getSideBarBranch,
  saveAddLeadDetails,
  searchCollegeDetails,
  searchCourseDetail,
  searchPartnerNameDetail,
  searchUniversityDetails,
} from "../../../redux/AddLead/action";
import useForm from "../../../common/hooks/useForm";
import UseFullLoader from "../../FullPageLoader/UseFullLoader";
import useSession from "../../CustomLogout/useSession";
import CustomLogout from "../../CustomLogout/CustomLogout";

import AsyncSelect from "react-select/async";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { trackEvent } from "../../../ga/index";

const AddLead = (props) => {
  const handleSessionExpired = useSession();

  const dispatch = useDispatch();

  const history = useNavigate();

  const qualificationType = useSelector(
    (state) =>
      state?.dashboardReducer?.dashboardDetails?.data?.dto?.qualifiedPartner
  );

  const partnerFirmID = useSelector(
    (state) => state?.auth?.loginCredentials?.data?.partnerFirmId
  );

  const [form] = Form.useForm();
  let partnerIdss;
  const { setListingRefresh, LogoutFlag } = props;

  const [loader, showLoader, hideLoader] = UseFullLoader();
  const [btnDisable, setBtnDisable] = useState(false);
  const FormItem = Form.Item;
  const { TextArea } = Input;
  let pincodeArray = [];
  const [open, setOpen] = useState(false);
  const onClose = () => {
    setOpen(false);
    form.resetFields();
    setState("");
    setValueRadio(291);
  };

  const handleAddEvent = () => {
    setOpen(true);
  };

  const { setFieldsValue } = form;
  const { state, onChangeTextHandler, setState } = useForm();
  const [selectedPincode, setSelectedPincode] = React.useState([]);
  const [pincodeId, setPincodeId] = React.useState(0);
  const [cityId, setCityId] = React.useState("");
  const [cityName, setCityName] = React.useState("");
  const [stateId, setStateId] = React.useState("");
  const [stateName, setStateName] = React.useState("");
  const [inputValue, setValue] = React.useState("");
  const [showUndecidedFields, setShowUndecidedFields] = useState(true);
  const [addLeadMasterData, setAddLeadMasterData] = useState();
  const [showDrowDown, setShowDrowDown] = useState(false);
  const [showSchool, setShowSchool] = useState(false);
  const [showCours, setshowCours] = useState(false);
  const [partnerFirmMSMEFlagCheck, setPartnerFirmMSMEFlagCheck] =
    useState(false);
  const [dataPartnerBranchPincode, setDataPartnerBranchPincode] = useState();
  const [stemRadio, setStemRadio] = useState(false);
  const [universityData, setUniversityData] = useState("");
  const [couresData, setCouresData] = useState("");
  const [instituteData, setInstituteData] = useState("");
  const [partnerBranch, setPartnerBranch] = useState([]);
  const [docvalue, setDocvalue] = useState(false);
  const [contactRadio, setContactRadio] = useState(false);
  const [leadId, setLeadId] = useState(0);
  const [reloptions, setRelOptions] = useState([]);
  const [valError, setValError] = useState(false);
  const [openPopover, setOpenPopover] = useState(false);
  const [leadStatusFlag, setLeadStatusFlag] = useState(false);
  const [popUpLabel, setPopUpLabel] = useState("");
  const [context, setContext] = useState("");
  const [nonQualifiedToQualified, setNonQualifiedToQualified] = useState(false);
  const [yesClick, setYesClick] = useState(false);
  const [noClick, setNoClick] = useState(false);
  const [trackQualified, setTrackQualified] = useState(false);
  const [courseType, setCourseType] = useState([]);
  const [loanType, setLoanType] = useState([]);
  const [submittedData, setSubmittedData] = useState(null);
  const onChangeDoc = (e) => {
    setDocvalue(!docvalue);
  };

  const [valueRadio, setValueRadio] = useState(291);

  const initialCoApplicantData = {
    incomeTobeConsideredFlag: true,
    required: true,
    applicantType: "CO_APPLICANT",
    emailAddress: "",
    firstName: "",
    fullname: "",
    lastName: "",
    middleName: "",
    dateOfBirth: 0, // Assuming dateOfBirth is a number field
    mobileNo: "",
    salutation: "",
    salutationId: "",
    relationship: "",
    relationshipId: "",
  };

  const initialCoApplicants = Array.from({ length: 2 }, (_, index) => ({
    id: index + 1,
    ...initialCoApplicantData,
    incomeTobeConsideredFlag: index === 0 ? true : false, // Set to true for the first co-applicant, false for others
  }));

  const [coApplicants, setCoApplicants] = useState(initialCoApplicants);
  const [relationData, setRelationData] = useState([]); // Assuming you have some data for the dropdown

  const handleChangeRelationData = (value, index) => {
    setCoApplicants((prevCoApplicants) => {
      return prevCoApplicants.map((applicant, i) => ({
        ...applicant,
        relationship: i === index ? value.label : applicant.relationship,
        relationshipId: i === index ? value.value : applicant.relationshipId,
      }));
    });
  };

  const onChangeCoApp = (e, name, index) => {
    // Extract the value from the event object
    const { value } = e.target;

    // Log the value (optional)

    // Update the coApplicants state by mapping over the existing array
    const updatedCoApplicants = coApplicants.map((applicant, i) =>
      // If the current index matches the specified index, update the specified field with the new value
      i === index ? { ...applicant, [name]: value } : applicant
    );

    // Set the state with the updated coApplicants array
    setCoApplicants(updatedCoApplicants);
  };

  const toggleIncomeTobeConsidered = (index) => {
    setCoApplicants((prevCoApplicants) => {
      return prevCoApplicants.map((applicant, i) => ({
        ...applicant,
        incomeTobeConsideredFlag:
          i == 0
            ? applicant.incomeTobeConsideredFlag
            : i == index
            ? !applicant.incomeTobeConsideredFlag
            : applicant.incomeTobeConsideredFlag,
      }));
    });
  };

  const addCoApplicant = () => {
    const newCoApplicant = {
      type: "newCoApplicant",
      ...initialCoApplicantData,
      incomeTobeConsideredFlag: false,
      required: true,
    };
    setCoApplicants([...coApplicants, newCoApplicant]);
  };

  const deleteCoApp = (index) => {
    // Use filter to create a new array without the coapplicant with the specified index
    const updatedCoApplicants = coApplicants.filter((_, i) => i !== index);

    // Update the state with the new array
    setCoApplicants(updatedCoApplicants);
  };

  const onChangeAdmission = (e) => {
    setValueRadio(e.target.value);
    setValError(false);
    setshowCours(false);
    setInstituteData("");
    setUniversityData("");
    form.setFieldsValue({
      university: "",
      universityText: "",
      instituteText: "",
      institute: "",
      courseText: "",
    });
    setState({
      ...state,
      universityText: "",
      instituteText: "",
      courseText: "",
    });
    setCouresData("");
    // form.resetFields("university");
  };

  const handleStemChanges = (e) => {
    setStemRadio(e.target.value);
  };
  const handleChangeQualification = (e) => {
    setContactRadio(e.target.value);
  };
  useEffect(() => {
    props
      .getAddLeadMasterList({
        access_token: props.auth?.accessToken?.access_token,
      })
      .then((res) => {
        if (res?.status === 200) {
          setAddLeadMasterData(res?.data?.dtoList);
        }

        // if (errorCode === "403" && res?.data?.error?.logoutStatus) {
        //   if (LogoutFlag?.logoutFlag) {
        //     return <CustomLogout />;
        //   } else {
        //     handleSessionExpired();
        //   }
        // }
        if (res?.data?.error || res.message) {
          const errorCode = res?.data?.error?.errorCode || res.errorCode;
          const errorMessage = res?.data?.error?.message || res.message;

          if (errorCode === "403" && res?.data?.error?.logoutStatus) {
            handleSessionExpired();
          } else {
            notification.error({
              description: errorMessage,
              duration: 5,
              placement: "top",
            });
          }
        }
      });
    props
      ?.getRelationshipDetails({
        access_token: props.auth?.accessToken?.access_token,
      })
      .then((res) => {
        const temp = res?.data?.dtoList;

        const data = temp.map((el) => {
          return {
            label: el?.descriptionInPennant,
            value: el?.codeInPennant,
          };
        });
        setRelOptions(data);
      });

    dispatch(
      getCourseTypeName({
        access_token: props.auth?.accessToken?.access_token,
        url: "ByName",
        name: "COURSE_TYPE_NAME",
      })
    ).then((res) => {
      if (res?.status === 200) {
        setCourseType(
          res?.data?.dtoList?.map((item) => ({
            label: item.code,
            value: item.serialId,
          }))
        );
      }
      if (res?.data?.error || res.message) {
        const errorCode = res?.data?.error?.errorCode || res.errorCode;
        const errorMessage = res?.data?.error?.message || res.message;
        if (errorCode === "403" && res?.data?.error?.logoutStatus) {
          handleSessionExpired();
        } else {
          notification.error({
            description: errorMessage,
            duration: 5,
            placement: "top",
          });
        }
      }
    });
    dispatch(
      getCourseTypeName({
        access_token: props.auth?.accessToken?.access_token,
        url: "ByName",
        name: "LOAN_TYPE",
      })
    ).then((res) => {
      if (res?.status === 200) {
        setLoanType(
          res?.data?.dtoList?.map((item) => ({
            label: item.code,
            value: item.serialId,
          }))
        );
      }
      if (res?.data?.error || res.message) {
        const errorCode = res?.data?.error?.errorCode || res.errorCode;
        const errorMessage = res?.data?.error?.message || res.message;
        if (errorCode === "403" && res?.data?.error?.logoutStatus) {
          handleSessionExpired();
        } else {
          notification.error({
            description: errorMessage,
            duration: 5,
            placement: "top",
          });
        }
      }
    });
  }, []);

  const countryData =
    addLeadMasterData?.length > 0
      ? addLeadMasterData.map((el) => {
          return {
            label: el.countryName,
            value: el.countryId,
          };
        })
      : [];

  const handleChangeCountryData = (val) => {
    setState({
      ...state,
      institute: "",
      course: "",
      university: "",
      country: {
        countryId: val.value,
        countryName: val.label,
      },
    });

    setUniversityData("");
    setInstituteData("");
    setCouresData("");
    form.setFieldValue("university", "");
    form.setFieldValue("institute", "");
    form.setFieldValue("course", "");
  };

  const handlelistHide = () => {
    setShowDrowDown(!showDrowDown);
    setUniversityData("");
    setInstituteData("");
    setCouresData("");
    form.setFieldsValue({
      university: "",
      institute: "",
      course: "",
    });

    setState({
      ...state,
      university: "",
      instituteText: "",
      universityText: "",
      courseText: "",

      institute: "",
      course: "",
    });
  };
  const handleinstitue = () => {
    setShowSchool(!showSchool);
    setInstituteData("");
    setState({
      ...state,

      instituteText: "",
      courseText: "",
    });
    setInstituteData("");
    setCouresData("");
    form.setFieldsValue({
      institute: "",
      course: "",
    });
  };

  const handlecoures = () => {
    setshowCours(!showCours);
    setCouresData("");
  };

  const loadUniversity = (universityInputValue, callback) => {
    let universityArray = [];
    if (universityInputValue.length > 2) {
      let params = {
        // universityName: universityInputValue,
        // instituteName: collegeInputValue,
        universityName: universityInputValue,
        countryId: state?.country?.countryId,
      };

      props
        .searchUniversityDetails({
          access_token: props.auth?.accessToken?.access_token,
          params,
        })
        .then((res) => {
          if (res && res.status === 200) {
            res?.data?.dtoList?.length > 0 &&
              res?.data?.dtoList?.forEach(function (element) {
                const values = {
                  value: element?.universityId,
                  label: element?.universityName,
                };
                universityArray.push(values);
              });
            callback(universityArray);
          } else {
            callback([]);
          }

          if (res?.data?.error || res.message) {
            const errorCode = res?.data?.error?.errorCode || res.errorCode;
            const errorMessage = res?.data?.error?.message || res.message;

            if (errorCode === "403" && res?.data?.error?.logoutStatus) {
              handleSessionExpired();
            } else {
              notification.error({
                description: errorMessage,
                duration: 5,
                placement: "top",
              });
            }
          }
        })
        .catch((err) => {
          callback([]);
        });
    }
  };

  const loadColleges = (collegeInputValue, callback) => {
    let collegeArray = [];
    if (collegeInputValue.length > 1) {
      let params = {
        // instituteName: collegeInputValue,
        // universityId: state?.university?.id,
        instituteName: collegeInputValue,
        universityId: state?.university?.value || state?.university?.id,
        countryId: state?.country?.countryId,
      };

      props
        .searchCollegeDetails({
          access_token: props.auth?.accessToken?.access_token,
          params,
        })
        .then((res) => {
          if (res && res.status === 200) {
            res?.data?.dtoList?.length > 0 &&
              res?.data?.dtoList?.forEach(function (element) {
                const values = {
                  value: element?.instituteId,
                  label: element?.instituteName,
                };
                collegeArray.push(values);
              });
            callback(collegeArray);
          } else {
            callback([]);
          }

          if (res?.data?.error || res.message) {
            const errorCode = res?.data?.error?.errorCode || res.errorCode;
            const errorMessage = res?.data?.error?.message || res.message;

            if (errorCode === "403" && res?.data?.error?.logoutStatus) {
              handleSessionExpired();
            } else {
              notification.error({
                description: errorMessage,
                duration: 5,
                placement: "top",
              });
            }
          }
        })
        .catch((err) => {
          callback([]);
        });
    }
  };

  const loadCourses = (courseInputValue, callback) => {
    let courseArray = [];
    if (courseInputValue.length > 2) {
      let params = {
        courseName: courseInputValue,
        instituteId: instituteData?.id,
      };

      props
        .searchCourseDetail({
          access_token: props.auth?.accessToken?.access_token,
          params,
        })
        .then((res) => {
          if (res && res.status === 200) {
            res?.data?.dtoList?.length > 0 &&
              res?.data?.dtoList?.forEach(function (element) {
                const values = {
                  value: element?.courseId,
                  label: element?.courseName,
                };
                courseArray.push(values);
              });
            callback(courseArray);
          } else {
            callback([]);
          }

          if (res?.data?.error || res.message) {
            const errorCode = res?.data?.error?.errorCode || res.errorCode;
            const errorMessage = res?.data?.error?.message || res.message;

            if (errorCode === "403" && res?.data?.error?.logoutStatus) {
              handleSessionExpired();
            } else {
              notification.error({
                description: errorMessage,
                duration: 5,
                placement: "top",
              });
            }
          }
        })
        .catch((err) => {
          callback([]);
        });
    }
  };

  const loadPartner = (partnerInputValue, callback) => {
    let partnerArray = [];
    if (partnerInputValue.length > 2) {
      props
        .searchPartnerNameDetail({
          access_token: props.auth?.accessToken?.access_token,
          partnerName: partnerInputValue,
        })
        .then((res) => {
          if (res && res.status === 200) {
            res?.data?.dtoList?.length > 0 &&
              res?.data?.dtoList?.forEach(function (element) {
                const values = {
                  value: element?.partnerFirmId,
                  label: element?.partnerFirmName,
                };
                partnerArray.push(values);
              });
            callback(partnerArray);
          } else {
            callback([]);
          }

          if (res?.data?.error || res.message) {
            const errorCode = res?.data?.error?.errorCode || res.errorCode;
            const errorMessage = res?.data?.error?.message || res.message;

            if (errorCode === "403" && res?.data?.error?.logoutStatus) {
              handleSessionExpired();
            } else {
              notification.error({
                description: errorMessage,
                duration: 5,
                placement: "top",
              });
            }
          }
        })
        .catch((err) => {
          callback([]);
        });
    }
  };

  const loadPincodes = (inputValue, callback) => {
    if (inputValue.length > 2) {
      props
        .getPincodeList({
          access_token: props.auth?.accessToken?.access_token,
          inputValue,
        })
        .then((res) => {
          if (res && res.status === 200) {
            res?.data?.dtoList?.length > 0 &&
              res?.data?.dtoList?.forEach(function (element) {
                const values = {
                  label: element.pincode,
                  value: element.pincodeId,
                };
                pincodeArray.push(values);
              });
            callback(pincodeArray);
          }
          if (res?.data?.error || res.message) {
            const errorCode = res?.data?.error?.errorCode || res.errorCode;
            const errorMessage = res?.data?.error?.message || res.message;

            if (errorCode === "403" && res?.data?.error?.logoutStatus) {
              handleSessionExpired();
            } else {
              notification.error({
                description: errorMessage,
                duration: 5,
                placement: "top",
              });
            }
          }
        });
    }
  };

  const getBranchLocationMaster = (pincodeId) => {
    props
      .getBranchLocationByPincode({
        access_token: props.auth?.accessToken?.access_token,
        url: "getAll/LocationsUsingPincodeId",
        pincode: pincodeId,
        data: {
          pincodeMaster: {
            pincodeId: pincodeId,
            pincode: inputValue,
            cityId: cityId,
            serviceable: true,
            groupId: 1,
            // area: area,
            active: true,
          },
          cityMaster: {
            cityName: cityName,
            cityId: cityId,
          },
          stateMaster: {
            stateName: stateName,
            stateId: stateId,
          },
        },
      })
      .then((res) => {
        if (res) {
          if (res && res.status === 200) {
            const { pincodeMaster, cityMaster, stateMaster } = res?.data;
            setPincodeId(pincodeMaster?.pincodeId);
            // setArea(pincodeMaster?.area);
            setCityId(cityMaster?.cityId);
            setStateId(stateMaster?.stateId);
            setStateName(stateMaster?.stateName);
            // setCountryId(countryMaster?.contryId);
            setCityName(cityMaster?.cityName);
            // setCountryName(countryMaster?.countryName);
            setFieldsValue({
              city: cityMaster?.cityName,
              state: stateMaster?.stateName,
            });
          }
          if (res?.data?.error || res.message) {
            const errorCode = res?.data?.error?.errorCode || res.errorCode;
            const errorMessage = res?.data?.error?.message || res.message;

            if (errorCode === "403" && res?.data?.error?.logoutStatus) {
              handleSessionExpired();
            } else {
              notification.error({
                description: errorMessage,
                duration: 5,
                placement: "top",
              });
            }
          }
        }
      });
  };

  const pincodeInputChange = (value) => {
    setValue(value);
  };
  const pincodeDropChange = (pincodeObj) => {
    setSelectedPincode(pincodeObj.label);

    getBranchLocationMaster(pincodeObj.value);
  };

  const getPincodeData = (pincode) => {
    props
      .getBranchLocationByArea({
        access_token: props.auth?.accessToken?.access_token,
        url: "getAll/Pincodes",
        pincode: pincode,
      })
      .then((res) => {
        const pincodeObj =
          res && res.data && res.data.dtoList && res.data.dtoList.length > 0
            ? res.data.dtoList.filter((pin) => pin.pincode == pincode)
            : "";
        const pincodeId =
          pincodeObj?.length > 0
            ? pincodeObj?.map((p) => p.pincodeId)?.flat(2)
            : "";

        setPincodeId(pincodeId?.length > 0 && pincodeId[0]);
        getBranchLocationMaster(pincodeId?.length > 0 && pincodeId[0]);

        if (res?.data?.error || res.message) {
          const errorCode = res?.data?.error?.errorCode || res.errorCode;
          const errorMessage = res?.data?.error?.message || res.message;

          if (errorCode === "403" && res?.data?.error?.logoutStatus) {
            handleSessionExpired();
          } else {
            notification.error({
              description: errorMessage,
              duration: 5,
              placement: "top",
            });
          }
        }
      });
  };

  const handleError = () => {};
  const handleUniversityChange = (val) => {
    setState({
      ...state,
      institute: "",
      course: "",
      university: {
        id: val.value,
        name: val.label,
      },
    });
    setUniversityData({
      id: val.value,
      name: val.label,
    });
    form.setFieldValue("university", {
      value: val.value,
      label: val.label,
    });
    // setValError(false);
    setInstituteData("");
    setCouresData("");
    form.setFieldValue("institute", "");
    form.setFieldValue("course", "");
  };

  const handleInstituteChange = (val) => {
    setState({
      ...state,
      course: "",
      institute: {
        id: val.value,
        name: val.label,
      },
    });
    setInstituteData({
      id: val.value,
      name: val.label,
    });

    form.setFieldValue("institute", {
      id: val.value,
      name: val.label,
    });

    setCouresData("");
    form.setFieldValue("course", "");
  };

  const handleCourseChange = (val) => {
    setState({
      ...state,
      course: {
        id: val.value,
        name: val.label,
      },
    });
    setCouresData({
      id: val.value,
      name: val.label,
    });
    form.setFieldValue("course", {
      id: val.value,
      name: val.label,
    });
  };

  const handleSelectPartnerChange = (val) => {
    setState({
      ...state,
      selectPartner: {
        id: val.value,
        name: val.label,
      },
    });
  };
  const partnerFirmId =
    props?.auth?.partnerFirmDetails?.partnerFirmId ||
    props?.partnerSidebar?.partnerSidebarDtoList?.[0]?.partnerFirmId;

  useEffect(() => {
    if (partnerFirmId) {
      props
        .getSideBarBranch({
          access_token: props.auth?.accessToken?.access_token,
          partnerFirmId: partnerFirmId,
        })
        .then((res) => {
          if (res?.status === 200) {
            setDataPartnerBranchPincode(res?.data);
          }
          if (res?.data?.error || res.message) {
            const errorCode = res?.data?.error?.errorCode || res.errorCode;
            const errorMessage = res?.data?.error?.message || res.message;

            if (errorCode === "403" && res?.data?.error?.logoutStatus) {
              handleSessionExpired();
            } else {
              notification.error({
                description: errorMessage,
                duration: 5,
                placement: "top",
              });
            }
          }
        });
    }
  }, [partnerFirmId]);

  const dataPartnerBranch =
    dataPartnerBranchPincode?.length > 0
      ? dataPartnerBranchPincode.map((el) => {
          return {
            label: ` ${el?.partnerBranchLocationAddress?.cityName} - (${el?.partnerBranchLocationAddress?.pincode})`,
            value: el.partnerBranchLocationAddress?.pincodeId,
          };
        })
      : [];

  const handleChangepartnerBranchPincodeData = (val) => {
    setState({
      ...state,
      partnerBranchPincode: {
        id: val.value,
        name: val.label,
        dataPartnerBranch: val.partnerBranchId,
      },
    });
    partnerIdss =
      dataPartnerBranchPincode?.length > 0
        ? dataPartnerBranchPincode
            .filter((el) => {
              return el?.partnerBranchLocationAddress?.pincode == val.label;
            })
            .map((el) => {
              return {
                partnerBranchId: el.partnerBranchId,
              };
            })
        : [];
    setPartnerBranch(partnerIdss);
  };

  const generateRandomNumber = () => {
    let randomNum = Math.random().toString().replace("0.", "");

    if (randomNum.length < 16) {
      randomNum += Math.random()
        .toString()
        .replace("0.", "")
        .substring(0, 16 - randomNum.length);
    } else if (randomNum.length > 16) {
      randomNum = randomNum.substring(0, 16);
    }
    return randomNum;
  };

  const handleInvokePopup = (Data) => {
    if (qualificationType === "LEAD") {
      const allData = { ...Data, ...state };
      setSubmittedData(allData);
      handleSubmitLeadDetails(allData, false);
    } else if (qualificationType === "APPLICATION") {
      const allData = { ...Data, ...state };
      handleSubmitLeadDetails(allData, true);
    } else {
      setPopUpLabel("Do you want to Upload documents");
      setContext("qualified");
      setOpenPopover(true);

      const allData = { ...Data, ...state };
      setSubmittedData(allData);
    }
  };

  const handleSubmitLeadDetails = (state, options) => {
    let leadPartnerTypeValue;

    if (qualificationType === "BOTH") {
      leadPartnerTypeValue = options ? "APPLICATION" : "LEAD";
    } else {
      leadPartnerTypeValue = qualificationType;
    }

    const data = {
      leadEmail: state?.email,
      leadFirstName: state?.firstName?.trim(),
      leadLastName: state?.lastName?.trim(),
      leadMobile: state?.mobile?.trim(),
      leadPincodeId: pincodeId,
      leadPincode: selectedPincode,
      leadStateId: stateId,
      leadCityId: cityId,
      leadStateName: stateName?.trim(),
      leadCityName: cityName?.trim(),
      countryOfStudyId: state?.country?.countryId,
      admissionStatusTypeId: valueRadio,
      courseId: couresData?.id ?? "",
      courseNotInList: showCours,
      universityId: !showDrowDown ? universityData?.id || "" : "",
      universityName: !showDrowDown ? universityData?.name || "" : "",
      instituteId: instituteData?.id ?? "",
      instituteNotInList: showSchool,
      otherCourse: showCours ? state?.courseText?.trim() ?? "" : "",
      otherInstitute: showSchool ? state?.instituteText?.trim() ?? "" : "",
      otherUniversity: showDrowDown ? state?.universityText?.trim() ?? "" : "",
      universityNotInList: showDrowDown,
      stemCourse: showCours ? stemRadio : "",
      amountRequested: state?.amountRequested,
      partnerLead: true,
      partnerBranchPincode: state?.partnerBranchPincode?.name,
      partnerBranchPincodeId: state?.partnerBranchPincode?.id,
      leadPancardNo: state?.leadPancardNo?.toUpperCase(),
      leadPassportNo: state?.leadPassportNo,
      partnerBranchId: partnerBranch[0]?.partnerBranchId,
      partnerFirmId: partnerFirmID,
      leadStatus: "NEW_LEADS",
      leadSource: "Partner",
      contactCenterQualification: false,
      uploadDocuments: docvalue,
      // leadCoApplicantList: coApplicants,
      leadStatusFlag: leadStatusFlag,
      leadCourseTypeName: state?.courseType?.value,
      leadLoanType: state?.loanType?.value,
      leadMonthOfAddmissionIntake: state?.monthOfAdmissionIntake || null,
      leadPartnerType: leadPartnerTypeValue,
    };

    if (qualificationType === "APPLICATION" || options === true) {
      data.leadDocumentIdentifier = generateRandomNumber();
    }

    setBtnDisable(true);

    props
      .saveAddLeadDetails({
        access_token: props.auth?.accessToken?.access_token,
        values: data,
      })
      .then((res) => {
        setBtnDisable(false);
        if (res && res.status === 200) {
          setBtnDisable(false);
          setValueRadio(291);
          notification.success({
            description: res?.data?.message,
            duration: 5,
            placement: "top",
          });
          setOpen(false);
          form.resetFields();

          const leadId = res.data?.Id;

          const isApplication =
            qualificationType === "APPLICATION" ||
            (qualificationType === "BOTH" && options === true);

          if (isApplication) {
            
            trackEvent("Application", partnerFirmId, leadId,{
              label: "Application Added",
              category: "Application",
              action: "Application",
            })

            history("/leadManagementDashboard/addLeadDoc", {
              state: { leadId },
            });
          } else {
            
            trackEvent("Lead", partnerFirmId, leadId,{
              label: "Lead Added",
              category: "Lead",
              action: "Lead",
            })

            history("/leadManagementDashboard/leadManagement");
          }

          dispatch(
            bucketChange(
              isApplication
                ? "NEW_LEADS"
                : qualificationType === "LEAD"
                ? "NEW_LEADS"
                : noClick
                ? "INCOMPLETE"
                : "NEW_LEADS"
            )
          );

          setListingRefresh(true);
        }
        if (res?.data?.error || res.message) {
          const errorCode = res?.data?.error?.errorCode || res.errorCode;
          const errorMessage = res?.data?.error?.message || res.message;
          setBtnDisable(false);

          const checkProcessed =
            res.data.error.message ===
            "Lead already logged in. Do you Still want to continue?";

          if (checkProcessed) {
            setPopUpLabel("Do you want to continue?");
            setContext("login");
            setOpenPopover(!openPopover);
          }

          if (errorCode === "403" && res?.data?.error?.logoutStatus) {
            handleSessionExpired();
          } else {
            trackEvent("Lead", partnerFirmId, "",{
              label: "Lead Failed",
              category: "Lead",
              action: "Lead",
            })
            notification.error({
              description: errorMessage,
              duration: 5,
              placement: "top",
            });
          }
        }
      });
  };

  const handlenewEooro = () => {
    setValError(true);
  };

  const hide = () => {
    setOpenPopover(false);
  };

  const handleOpenChange = () => {
    setOpenPopover(!openPopover);
  };

  const handleYesClick = () => {
    handleSubmitLeadDetails(submittedData, true);
    hide();
  };

  const handleNoClick = () => {
    handleSubmitLeadDetails(submittedData, false);
    hide();
  };

  const handleMobileNumberKeyPress = (event) => {
    const { key, target } = event;
    const isValueExceedingLimit = target.value.length >= 10;

    if ((!/^\d$/.test(key) && key !== ".") || isValueExceedingLimit) {
      event.preventDefault();
    }
  };

  return (
    <div>
      {loader}
      {LogoutFlag?.logoutFlag ? <CustomLogout /> : ""}

      <Form
        name="addLead"
        autoComplete="off"
        form={form}
        onFinish={handleInvokePopup}
      >
        <div className="form-inner-content new-se">
          <div className="content-sc-drawer">
            <div className="header-sec-drawer">
              <UISectionHeading drawerHeading="Add New Lead" />
            </div>

            <div className="form-sec-drawer">
              <Row>
                <Col lg={12} xs={12} md={12} sm={12} className="inner-sec-text">
                  <Col md={5} className="">
                    <FormItem
                      name="firstName"
                      label="First Name"
                      colon={false}
                      rules={[
                        {
                          required: true,
                          message: "Please Enter First Name",
                        },
                        {
                          pattern: new RegExp("^[a-zA-Z ]+$"),
                          message: "please enter a valid first name",
                        },
                      ]}
                    >
                      <TextInput
                        type="text"
                        name="firstName"
                        onInput={(e) => {
                          // Remove leading whitespaces
                          const trimmedValue = e.target.value.trimStart();
                          e.target.value = trimmedValue;

                          if (trimmedValue !== "") {
                            // Check if the input contains only alphabetical characters
                            e.target.value = new RegExp("^[a-zA-Z ]+$").test(
                              trimmedValue
                            )
                              ? trimmedValue
                              : trimmedValue.substring(
                                  0,
                                  trimmedValue.length - 1
                                );
                          }
                        }}
                        value={state.firstName}
                        onChange={onChangeTextHandler}
                        maxLength={75}
                      />
                    </FormItem>
                  </Col>
                  <Col md={5} className="">
                    <FormItem
                      name="lastName"
                      label="Last Name"
                      colon={false}
                      rules={[
                        {
                          required: true,
                          message: "Please Enter Last Name",
                        },
                        {
                          pattern: new RegExp("^[a-zA-Z ]+$"),
                          message: "please enter a valid last name",
                        },
                      ]}
                    >
                      <TextInput
                        name="lastName"
                        onInput={(e) => {
                          // Remove leading whitespaces
                          const trimmedValue = e.target.value.trimStart();
                          e.target.value = trimmedValue;

                          if (trimmedValue !== "") {
                            // Check if the input contains only alphabetical characters
                            e.target.value = new RegExp("^[a-zA-Z ]+$").test(
                              trimmedValue
                            )
                              ? trimmedValue
                              : trimmedValue.substring(
                                  0,
                                  trimmedValue.length - 1
                                );
                          }
                        }}
                        value={state.lastName}
                        onChange={onChangeTextHandler}
                        type="text"
                        maxLength={75}
                      />
                    </FormItem>
                  </Col>
                </Col>
              </Row>
              <Row>
                <Col
                  lg={12}
                  xs={12}
                  md={12}
                  sm={12}
                  className="inner-sec-text first-sec-mon"
                >
                  <Col md={7} className="">
                    <FormItem
                      name="email"
                      label="Email Address"
                      colon={false}
                      rules={[
                        {
                          required: false,
                          message: "Please Enter Email Address",
                        },
                        {
                          pattern:
                            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                          message: "Please Enter a valid Email!",
                        },
                      ]}
                    >
                      <TextInput
                        maxLength={255}
                        onInput={(e) => {
                          if (e.target.value.trim() == "") {
                            e.target.value = e.target.value.trim();
                          }

                          if (e.target.value.trim() !== "") {
                            e.target.value = e.target.value.trimStart();
                          }
                        }}
                        type="email"
                        name="email"
                        value={state.email}
                        onChange={onChangeTextHandler}
                      />
                    </FormItem>
                  </Col>
                  <Col md={5} className="">
                    <FormItem
                      name="mobile"
                      label="Mobile"
                      colon={false}
                      rules={[
                        {
                          required: true,
                          message: "Please Enter Mobile Number",
                        },
                        ({ getFieldValue }) => ({
                          validator(_, value) {
                            if (!value || /^[6-9][0-9]{9}$/.test(value)) {
                              return Promise.resolve();
                            }
                            return Promise.reject("Invalid mobile number");
                          },
                        }),
                      ]}
                    >
                      <TextInput
                        name="mobile"
                        type="text"
                        maxLength={10}
                        value={state.mobile}
                        onInput={(e) => {
                          if (e.target.value.trim() == "") {
                            e.target.value = e.target.value.trim();
                          }

                          if (e.target.value.trim() !== "") {
                            e.target.value = new RegExp("^[0-9-+]*$").test(
                              e.target.value
                            )
                              ? e.target.value?.trimStart()
                              : e.target.value
                                  ?.trimStart()
                                  ?.substring(0, e.target.value.length - 1);
                          }
                        }}
                        onChange={onChangeTextHandler}
                        onKeyPress={handleMobileNumberKeyPress}
                      />
                    </FormItem>
                  </Col>
                </Col>
              </Row>

              <Row>
                <Col
                  lg={12}
                  xs={12}
                  md={12}
                  sm={12}
                  className="inner-sec-text list-sec-row"
                >
                  <Col md={4} className="pincode-sec">
                    <FormItem
                      name="pincode"
                      label="Pin code"
                      colon={false}
                      rules={[
                        {
                          required: true,
                          message: "Please Enter Pin code",
                        },
                      ]}
                    >
                      <AsyncSelect
                        className="pinNew"
                        // cacheOptions
                        maxLength="7"
                        value={inputValue}
                        loadOptions={loadPincodes}
                        onInputChange={(e) => pincodeInputChange(e)}
                        onChange={pincodeDropChange}
                      />
                    </FormItem>
                  </Col>

                  <Col md={4} className="">
                    <FormItem
                      name="city"
                      label="City"
                      colon={false}
                      rules={[
                        {
                          required: true,
                          message: "Please Enter City",
                        },
                      ]}
                    >
                      <TextInput
                        value={state.city}
                        onChange={onChangeTextHandler}
                        type="text"
                        disabled={true}
                      />
                    </FormItem>
                  </Col>
                  <Col md={4} className="">
                    <FormItem
                      name="state"
                      label="State"
                      colon={false}
                      rules={[
                        {
                          required: true,
                          message: "Please Enter State",
                        },
                      ]}
                    >
                      <TextInput
                        value={state.state}
                        onChange={onChangeTextHandler}
                        type="text"
                        disabled={true}
                      />
                    </FormItem>
                  </Col>
                </Col>
              </Row>
              <br></br>

              <Row>
                <Col md={5} className="">
                  <FormItem
                    name="leadPancardNo"
                    label="Student Pan"
                    colon={false}
                    rules={[
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          if (!value) {
                            return Promise.resolve(); // Allow empty input
                          }

                          const panRegex = /^[A-Z]{3}P[A-Z][0-9]{4}[A-Z]{1}$/;

                          if (panRegex.test(value.toUpperCase())) {
                            return Promise.resolve(); // Valid PAN
                          }

                          if (
                            value.length === 10 &&
                            value[3].toUpperCase() !== "P"
                          ) {
                            return Promise.reject(
                              "The 4th letter should be 'P'"
                            );
                          }

                          return Promise.reject("Invalid PAN number");
                        },
                      }),
                    ]}
                  >
                    <TextInput
                      name="leadPancardNo"
                      value={state.leadPancardNo}
                      style={{ textTransform: "uppercase" }}
                      onInput={(e) => {
                        if (e.target.value.trim() == "") {
                          e.target.value = e.target.value.trim();
                        }

                        if (e.target.value.trim() !== "") {
                          e.target.value = e.target.value.trimStart();
                        }
                      }}
                      onChange={onChangeTextHandler}
                      type="text"
                      maxLength={10}
                      onKeyPress={handleMobileNumberKeyPress}
                    />
                  </FormItem>
                </Col>

                <Col md={5} className="">
                  <FormItem
                    name="leadPassportNo"
                    label="Passport"
                    colon={false}
                    rules={[
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          if (!value || /^[A-Z][0-9]{7}$/.test(value)) {
                            return Promise.resolve();
                          }
                          return Promise.reject("Invalid Passport Number");
                        },
                      }),
                    ]}
                  >
                    <TextInput
                      name="leadPassportNo"
                      value={state.leadPassportNo}
                      onInput={(e) => {
                        if (e.target.value.trim() == "") {
                          e.target.value = e.target.value.trim();
                        }

                        if (e.target.value.trim() !== "") {
                          e.target.value = e.target.value.trimStart();
                        }
                      }}
                      onChange={onChangeTextHandler}
                      type="text"
                      maxLength={10}
                      onKeyPress={handleMobileNumberKeyPress}
                    />
                  </FormItem>
                </Col>
              </Row>

              <Row>
                <Col
                  lg={12}
                  xs={12}
                  md={12}
                  sm={12}
                  className="inner-sec-textt"
                >
                  <Col md={4} className="coApprelation">
                    <FormItem
                      name="courseType"
                      label="Course Type"
                      colon={false}
                      rules={[
                        {
                          required: true,
                          message: "Please Select Course Type",
                        },
                      ]}
                    >
                      <UiDropDown
                        className="newPin"
                        placeholder="Select"
                        data={courseType}
                        onChange={(value) => {
                          onChangeTextHandler({
                            target: { name: "courseType", value },
                          });
                        }}
                        value={state.courseType}
                      />
                    </FormItem>
                  </Col>
                  <Col md={4} className="coApprelation">
                    <FormItem name="loanType" label="Loan Type" colon={false}>
                      <UiDropDown
                        className="newPin"
                        placeholder="Select"
                        data={loanType}
                        onChange={(value) => {
                          onChangeTextHandler({
                            target: { name: "loanType", value },
                          });
                        }}
                        value={state.loanType}
                      />
                    </FormItem>
                  </Col>
                  <Col md={4} className="coApprelation">
                    <FormItem
                      name="monthOfAdmissionIntake"
                      label="Month of Admission Intake"
                      colon={false}
                    >
                      <TextInput
                        name="monthOfAdmissionIntake"
                        value={state.monthOfAdmissionIntake}
                        onChange={onChangeTextHandler}
                        type="text"
                        maxLength={20}
                      />
                    </FormItem>
                  </Col>
                </Col>
              </Row>

              <br />
              <br />

              <h3 className="main-sec-inter">Admission Info</h3>

              <Row>
                <Col lg={12} xs={12} md={12} sm={12} className="inner-sec-text">
                  <Col md={10} className="cheched-grop-sec">
                    <FormItem
                      name="admissionStatus"
                      label="Admission Status"
                      colon={false}
                      rules={[
                        {
                          required: false,
                          message: "Please Select Admission Status",
                        },
                      ]}
                    >
                      <Radio.Group
                        name="admissionStatus"
                        defaultValue={291}
                        onChange={onChangeAdmission}
                        value={state.admissionStatus}
                      >
                        <Radio value={291}>Undecided</Radio>
                        <Radio value={292}>Applied</Radio>
                        <Radio value={293}>Confirmed</Radio>
                      </Radio.Group>
                    </FormItem>
                  </Col>
                </Col>
              </Row>

              <Row>
                <Col
                  lg={12}
                  xs={12}
                  md={12}
                  sm={12}
                  className="inner-sec-text sec-check-list"
                >
                  <Col md={6} className="">
                    <FormItem
                      name="country"
                      label="Country"
                      colon={false}
                      rules={[
                        {
                          required:
                            valueRadio === 292 || valueRadio === 293
                              ? true
                              : false,
                          message: "Please Select Country",
                        },
                      ]}
                    >
                      <UiDropDown
                        data={countryData}
                        onChange={handleChangeCountryData}
                      />
                    </FormItem>
                  </Col>
                </Col>
              </Row>

              {valueRadio === 292 ? (
                <>
                  <Row>
                    <Col
                      lg={12}
                      xs={12}
                      md={12}
                      sm={12}
                      className="inner-sec-text university-sec"
                    >
                      <Col md={6} className="unver-sec">
                        {!showDrowDown ? (
                          <>
                            <FormItem
                              name="university"
                              label="University Name"
                              colon={false}
                              rules={[
                                {
                                  required: true,
                                },
                              ]}
                              validateStatus={
                                valError && !universityData
                                  ? "error"
                                  : "success"
                              }
                              help={
                                valError && !universityData
                                  ? "Please Select University"
                                  : ""
                              }
                            >
                              <div
                                className="list-sec-option-btn"
                                onClick={handlelistHide}
                              >
                                Not In List
                              </div>
                              <AsyncSelect
                                value={
                                  universityData
                                    ? {
                                        label: universityData.name,
                                        value: universityData.id,
                                      }
                                    : ""
                                }
                                placeholder={"Type 3 letters"}
                                loadOptions={loadUniversity}
                                onChange={handleUniversityChange}
                                // cacheOptions
                              />
                            </FormItem>
                          </>
                        ) : (
                          <>
                            <FormItem
                              name="universityText"
                              label="University Name"
                              colon={false}
                              rules={[
                                {
                                  required: true,
                                },
                              ]}
                              validateStatus={
                                valError && !state?.universityText
                                  ? "error"
                                  : "success"
                              }
                              help={
                                valError && !state?.universityText
                                  ? "Please Enter University"
                                  : ""
                              }
                            >
                              <div
                                className="list-sec-option-btn"
                                onClick={handlelistHide}
                              >
                                Select From List
                              </div>
                              <TextInput
                                name="universityText"
                                maxLength={200}
                                value={state.universityText}
                                onInput={(e) => {
                                  if (e.target.value.trim() == "") {
                                    e.target.value = e.target.value.trim();
                                  }

                                  if (e.target.value.trim() !== "") {
                                    e.target.value = e.target.value.trimStart();
                                  }
                                }}
                                onChange={onChangeTextHandler}
                                type="text"
                              />
                            </FormItem>
                          </>
                        )}
                      </Col>
                      <Col md={6} className="unver-sec">
                        {!showSchool ? (
                          <>
                            <FormItem
                              name="institute"
                              label="School / Institue Name"
                              colon={false}
                              rules={[
                                {
                                  required: true,
                                },
                              ]}
                              validateStatus={
                                valError && !instituteData ? "error" : "success"
                              }
                              help={
                                valError && !instituteData
                                  ? "Please Select School/Institue Name"
                                  : ""
                              }
                            >
                              <div
                                className="list-sec-option-btn"
                                onClick={handleinstitue}
                              >
                                Not In List
                              </div>
                              <AsyncSelect
                                value={
                                  instituteData
                                    ? {
                                        label: instituteData.name,
                                        value: instituteData.id,
                                      }
                                    : ""
                                }
                                isClearable={true}
                                placeholder={"Type 3 letters"}
                                loadOptions={loadColleges}
                                onChange={handleInstituteChange}
                              />
                            </FormItem>
                          </>
                        ) : (
                          <>
                            <FormItem
                              name="instituteText"
                              label="School / Institue Name"
                              colon={false}
                              rules={[
                                {
                                  required: true,
                                },
                              ]}
                              validateStatus={
                                valError && !state?.instituteText
                                  ? "error"
                                  : "success"
                              }
                              help={
                                valError && !state?.instituteText
                                  ? "Please Enter School/Institue Name"
                                  : ""
                              }
                            >
                              <div
                                className="list-sec-option-btn"
                                onClick={handleinstitue}
                              >
                                Select From List
                              </div>
                              <TextInput
                                name="instituteText"
                                type="text"
                                onInput={(e) => {
                                  if (e.target.value.trim() == "") {
                                    e.target.value = e.target.value.trim();
                                  }

                                  if (e.target.value.trim() !== "") {
                                    e.target.value = e.target.value.trimStart();
                                  }
                                }}
                                value={state.instituteText}
                                onChange={onChangeTextHandler}
                                maxLength={200}
                              />
                            </FormItem>
                          </>
                        )}
                      </Col>
                    </Col>
                  </Row>

                  <Row>
                    <Col
                      lg={12}
                      xs={12}
                      md={12}
                      sm={12}
                      className="inner-sec-text university-sec"
                    >
                      <Col md={6} className="unver-sec">
                        {!showCours ? (
                          <>
                            <FormItem
                              name="course"
                              label="Course"
                              colon={false}
                              rules={[
                                {
                                  required: true,
                                },
                              ]}
                              validateStatus={
                                valError && !couresData ? "error" : "success"
                              }
                              help={
                                valError && !couresData
                                  ? "Please Select Course"
                                  : ""
                              }
                            >
                              {" "}
                              <div
                                className="list-sec-option-btn"
                                onClick={handlecoures}
                              >
                                Not In List
                              </div>
                              <AsyncSelect
                                value={
                                  couresData
                                    ? {
                                        label: couresData.name,
                                        value: couresData.id,
                                      }
                                    : ""
                                }
                                placeholder={"Type 3 letters"}
                                loadOptions={loadCourses}
                                onChange={handleCourseChange}
                                isClearable={true}
                                // cacheOptions
                              />
                            </FormItem>
                          </>
                        ) : (
                          <>
                            <FormItem
                              name="courseText"
                              label="Course"
                              colon={false}
                              rules={[
                                {
                                  required: true,
                                },
                              ]}
                              validateStatus={
                                valError && !state?.courseText
                                  ? "error"
                                  : "success"
                              }
                              help={
                                valError && !state?.courseText
                                  ? "Please Enter Course"
                                  : ""
                              }
                            >
                              <div
                                className="list-sec-option-btn"
                                onClick={handlecoures}
                              >
                                Select From List
                              </div>
                              <TextInput
                                name="courseText"
                                maxLength={200}
                                type="text"
                                onInput={(e) => {
                                  if (e.target.value.trim() == "") {
                                    e.target.value = e.target.value.trim();
                                  }

                                  if (e.target.value.trim() !== "") {
                                    e.target.value = e.target.value.trimStart();
                                  }
                                }}
                                value={state.courseText}
                                onChange={onChangeTextHandler}
                              />
                            </FormItem>
                          </>
                        )}
                      </Col>
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      lg={12}
                      xs={12}
                      md={12}
                      sm={12}
                      className="inner-sec-text"
                    >
                      <Col md={10} className="cheched-grop-sec">
                        {showCours && (
                          <FormItem
                            name="stem"
                            label="Stem/Programme Type"
                            colon={false}
                            rules={[
                              {
                                required: false,
                                message: "Please Please Strem/Programme Type",
                              },
                            ]}
                          >
                            <Radio.Group
                              onChange={handleStemChanges}
                              value={stemRadio}
                            >
                              <Radio value={true}>Stem</Radio>
                              <Radio value={false}>Non Stem</Radio>
                            </Radio.Group>
                          </FormItem>
                        )}
                      </Col>
                    </Col>
                  </Row>
                </>
              ) : null}

              {valueRadio === 293 ? (
                <>
                  <Row>
                    <Col
                      lg={12}
                      xs={12}
                      md={12}
                      sm={12}
                      className="inner-sec-text university-sec"
                    >
                      <Col md={6} className="unver-sec">
                        {!showDrowDown ? (
                          <>
                            <FormItem
                              name="university"
                              label="University Name"
                              colon={false}
                              rules={[
                                {
                                  required: true,
                                },
                              ]}
                              validateStatus={
                                valError && !universityData
                                  ? "error"
                                  : "success"
                              }
                              help={
                                valError && !universityData
                                  ? "Please Select University"
                                  : ""
                              }
                            >
                              <div
                                className="list-sec-option-btn"
                                onClick={handlelistHide}
                              >
                                Not In List
                              </div>
                              <AsyncSelect
                                placeholder={"Type 3 letters"}
                                loadOptions={loadUniversity}
                                onChange={handleUniversityChange}
                                value={
                                  universityData
                                    ? {
                                        label: universityData.name,
                                        value: universityData.id,
                                      }
                                    : ""
                                }
                                // cacheOptions
                              />
                            </FormItem>
                          </>
                        ) : (
                          <>
                            <FormItem
                              name="universityText"
                              label="University Name"
                              colon={false}
                              rules={[
                                {
                                  required: true,
                                },
                              ]}
                              validateStatus={
                                valError && !state?.universityText
                                  ? "error"
                                  : "success"
                              }
                              help={
                                valError && !state?.universityText
                                  ? "Please Enter University"
                                  : ""
                              }
                            >
                              <div
                                className="list-sec-option-btn"
                                onClick={handlelistHide}
                              >
                                Select From List
                              </div>
                              <TextInput
                                name="universityText"
                                value={state.universityText}
                                onInput={(e) => {
                                  if (e.target.value.trim() == "") {
                                    e.target.value = e.target.value.trim();
                                  }

                                  if (e.target.value.trim() !== "") {
                                    e.target.value = e.target.value.trimStart();
                                  }
                                }}
                                onChange={onChangeTextHandler}
                                type="text"
                                maxLength={255}
                              />
                            </FormItem>
                          </>
                        )}
                      </Col>
                      <Col md={6} className="unver-sec">
                        {!showSchool ? (
                          <>
                            <FormItem
                              name="institute"
                              label="School / Institue Name"
                              colon={false}
                              rules={[
                                {
                                  required: true,
                                },
                              ]}
                              validateStatus={
                                valError && !instituteData ? "error" : "success"
                              }
                              help={
                                valError && !instituteData
                                  ? "Please Select School/Institue Name"
                                  : ""
                              }
                            >
                              <div
                                className="list-sec-option-btn"
                                onClick={handleinstitue}
                              >
                                Not In List
                              </div>
                              <AsyncSelect
                                isClearable={true}
                                placeholder={"Type 3 letters"}
                                loadOptions={loadColleges}
                                onChange={handleInstituteChange}
                                value={
                                  instituteData
                                    ? {
                                        label: instituteData.name,
                                        value: instituteData.id,
                                      }
                                    : ""
                                }
                              />
                            </FormItem>
                          </>
                        ) : (
                          <>
                            <FormItem
                              name="instituteText"
                              label="School / Institue Name"
                              colon={false}
                              rules={[
                                {
                                  required: true,
                                },
                              ]}
                              validateStatus={
                                valError && !state?.instituteText
                                  ? "error"
                                  : "success"
                              }
                              help={
                                valError && !state?.instituteText
                                  ? "Please Enter School/Institue Name"
                                  : ""
                              }
                            >
                              <div
                                className="list-sec-option-btn"
                                onClick={handleinstitue}
                              >
                                Select From List
                              </div>
                              <TextInput
                                name="instituteText"
                                type="text"
                                onInput={(e) => {
                                  if (e.target.value.trim() == "") {
                                    e.target.value = e.target.value.trim();
                                  }

                                  if (e.target.value.trim() !== "") {
                                    e.target.value = e.target.value.trimStart();
                                  }
                                }}
                                value={state.instituteText}
                                onChange={onChangeTextHandler}
                                maxLength={255}
                              />
                            </FormItem>
                          </>
                        )}
                      </Col>
                    </Col>
                  </Row>

                  <Row>
                    <Col
                      lg={12}
                      xs={12}
                      md={12}
                      sm={12}
                      className="inner-sec-text university-sec"
                    >
                      <Col md={6} className="unver-sec">
                        {!showCours ? (
                          <>
                            <FormItem
                              name="course"
                              label="Course"
                              colon={false}
                              rules={[
                                {
                                  required: true,
                                },
                              ]}
                              validateStatus={
                                valError && !couresData ? "error" : "success"
                              }
                              help={
                                valError && !couresData
                                  ? "Please Select Course"
                                  : ""
                              }
                            >
                              {" "}
                              <div
                                className="list-sec-option-btn"
                                onClick={handlecoures}
                              >
                                Not In List
                              </div>
                              <AsyncSelect
                                placeholder={"Type 3 letters"}
                                loadOptions={loadCourses}
                                onChange={handleCourseChange}
                                isClearable={true}
                                value={
                                  couresData
                                    ? {
                                        label: couresData.name,
                                        value: couresData.id,
                                      }
                                    : ""
                                }
                                // cacheOptions
                              />
                            </FormItem>
                          </>
                        ) : (
                          <>
                            <FormItem
                              name="courseText"
                              label="Course"
                              colon={false}
                              rules={[
                                {
                                  required: true,
                                },
                              ]}
                              validateStatus={
                                valError && !state?.courseText
                                  ? "error"
                                  : "success"
                              }
                              help={
                                valError && !state?.courseText
                                  ? "Please Enter Course"
                                  : ""
                              }
                            >
                              <div
                                className="list-sec-option-btn"
                                onClick={handlecoures}
                              >
                                Select From List
                              </div>
                              <TextInput
                                name="courseText"
                                type="text"
                                onInput={(e) => {
                                  if (e.target.value.trim() == "") {
                                    e.target.value = e.target.value.trim();
                                  }

                                  if (e.target.value.trim() !== "") {
                                    e.target.value = e.target.value.trimStart();
                                  }
                                }}
                                value={state.courseText}
                                onChange={onChangeTextHandler}
                                maxLength={255}
                              />
                            </FormItem>
                          </>
                        )}
                      </Col>
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      lg={12}
                      xs={12}
                      md={12}
                      sm={12}
                      className="inner-sec-text"
                    >
                      <Col md={10} className="cheched-grop-sec">
                        {showCours && (
                          <FormItem
                            name="stem"
                            label="Stem/Programme Type"
                            colon={false}
                            rules={[
                              {
                                required: false,
                                message: "Please Strem/Programme Type",
                              },
                            ]}
                          >
                            <Radio.Group
                              onChange={handleStemChanges}
                              value={stemRadio}
                            >
                              <Radio value={true}>Stem</Radio>
                              <Radio value={false}>Non Stem</Radio>
                            </Radio.Group>
                          </FormItem>
                        )}
                      </Col>
                    </Col>
                  </Row>
                </>
              ) : null}

              <br></br>

              <Row>
                <Col lg={12} xs={12} md={12} sm={12} className="inner-sec-text">
                  <Col md={6} className="cheched-grop-sec">
                    <FormItem
                      name="amountRequested"
                      label="Required Amount"
                      colon={false}
                      rules={[
                        {
                          required: false,
                          message: "Please Please Amount Requested",
                        },
                      ]}
                    >
                      {/* <TextInput
                          name="amountRequested"
                          type="number"
                          value={state.amountRequested}
                          onChange={onChangeTextHandler}
                        /> */}
                      <InputNumber
                        className="amtinpt"
                        maxLength={255}
                        formatter={(value) => {
                          const numFormat = new Intl.NumberFormat("en-IN");
                          if (value === "") {
                            return value;
                          }
                          const numericValue = Number(
                            value.replace(/[^\d.]/g, "")
                          );
                          if (isNaN(numericValue)) {
                            return "";
                          }
                          return numFormat.format(numericValue);
                        }}
                        parser={(value) => value.replace(/[^\d.]/g, "")}
                        // value={state.amountRequested}
                        onChange={onChangeTextHandler}
                        onKeyDown={(e) => {
                          if (
                            // Allow numeric keys and navigation keys
                            !e.key.match(/^\d$/) &&
                            e.key !== "Tab" &&
                            e.key !== "Backspace" &&
                            e.key !== "ArrowLeft" &&
                            e.key !== "ArrowRight"
                          ) {
                            e.preventDefault();
                          }
                        }}
                      />
                    </FormItem>
                  </Col>
                  <Col md={6} className="coApprelation">
                    <FormItem
                      name="partnerBranchPincode"
                      label="Partner Branch Pincode"
                      colon={false}
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: "Please Enter Partner Branch Pincode",
                      //   },
                      // ]}
                    >
                      <UiDropDown
                        className="newPin"
                        data={dataPartnerBranch}
                        onChange={handleChangepartnerBranchPincodeData}
                      />
                    </FormItem>
                  </Col>
                </Col>
              </Row>

              {/* <h3 className="main-sec-inter">CoApplicant Info</h3>
              <br></br>
              <br></br>
              <br></br> */}

              {/* <>
                {coApplicants.map((applicant, index) => {
                  form.setFieldValue(
                    `CoAppfirstName${index}`,
                    applicant.firstName
                  );

                  form.setFieldValue(
                    `CoApplastName${index}`,
                    applicant.lastName
                  );

                  form.setFieldValue(
                    `CoAppMobileNo${index}`,
                    applicant.mobileNo
                  );
                  if (applicant?.relationship && applicant?.relationshipId) {
                    form.setFieldValue(`CoAppRelation${index}`, {
                      label: applicant?.relationship,
                      value: applicant?.relationshipId,
                    });
                  }

                  form.setFieldValue(
                    `CoAppEmail${index}`,
                    applicant.emailAddress
                  );
                  return (
                    <>
                      <Row>
                        <Col
                          lg={12}
                          xs={12}
                          md={12}
                          sm={12}
                          className="inner-sec-text first-sec-mon"
                        >
                          <Col md={3}>
                            <h5>{`CoApplicant ${index + 1}`}</h5>
                          </Col>
                          <Col md={4} style={{ display: "flex" }}>
                            <FormItem
                              name="considerIncome"
                              label=""
                              colon={false}
                              rules={[
                                {
                                  required: false,
                                  message: "Please Please Strem/Programme Type",
                                },
                              ]}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <Checkbox
                                  className="addleadcheckbox"
                                  checked={applicant.incomeTobeConsideredFlag}
                                  onChange={() =>
                                    toggleIncomeTobeConsidered(index)
                                  }
                                  disabled={index == 0}
                                />
                                <h6>Income to be considered</h6>
                              </div>
                            </FormItem>
                          </Col>
                          <Col md={5}></Col>
                          <Col md={2}>
                            {applicant.type == "newCoApplicant" && (
                              <CloseOutlined
                                onClick={() => {
                                  deleteCoApp(index);
                                }}
                              />
                            )}
                          </Col>
                        </Col>
                      </Row>
                      <Row>
                        <Col
                          lg={12}
                          xs={12}
                          md={12}
                          sm={12}
                          className="inner-sec-text first-sec-mon"
                        >
                          <Col md={5} className="">
                            <FormItem
                              name={`CoAppfirstName${index}`}
                              label="First Name"
                              colon={false}
                              rules={[
                                {
                                  required: applicant?.required,
                                  message: "Please Enter First Name",
                                },
                                {
                                  pattern: new RegExp("^[a-zA-Z ]+$"),
                                  message: "please enter a valid first name",
                                },
                              ]}
                            >
                              <TextInput
                                onInput={(e) => {
                                  // Remove leading whitespaces
                                  const trimmedValue =
                                    e.target.value.trimStart();
                                  e.target.value = trimmedValue;

                                  if (trimmedValue !== "") {
                                    // Check if the input contains only alphabetical characters
                                    e.target.value = new RegExp(
                                      "^[a-zA-Z ]+$"
                                    ).test(trimmedValue)
                                      ? trimmedValue
                                      : trimmedValue.substring(
                                          0,
                                          trimmedValue.length - 1
                                        );
                                  }
                                }}
                                name={`CoAppfirstName${index}`}
                                type="text"
                                value={applicant.firstName}
                                onChange={(e) =>
                                  onChangeCoApp(e, "firstName", index)
                                }
                                maxLength={75}
                              />
                            </FormItem>
                          </Col>
                          <Col md={5} className="">
                            <FormItem
                              name={`CoApplastName${index}`}
                              label="Last Name"
                              colon={false}
                              rules={[
                                {
                                  required: applicant?.required,
                                  message: "Please Enter Last Name",
                                },
                                {
                                  pattern: new RegExp("^[a-zA-Z ]+$"),
                                  message: "please enter a valid last name",
                                },
                              ]}
                            >
                              <TextInput
                                name={`CoApplastName${index}`}
                                onInput={(e) => {
                                  // Remove leading whitespaces
                                  const trimmedValue =
                                    e.target.value.trimStart();
                                  e.target.value = trimmedValue;

                                  if (trimmedValue !== "") {
                                    // Check if the input contains only alphabetical characters
                                    e.target.value = new RegExp(
                                      "^[a-zA-Z ]+$"
                                    ).test(trimmedValue)
                                      ? trimmedValue
                                      : trimmedValue.substring(
                                          0,
                                          trimmedValue.length - 1
                                        );
                                  }
                                }}
                                value={applicant.lastName}
                                onChange={(e) =>
                                  onChangeCoApp(e, "lastName", index)
                                }
                                type="text"
                                maxLength={75}
                              />
                            </FormItem>
                          </Col>
                        </Col>
                      </Row>

                      <Row>
                        <Col
                          lg={12}
                          xs={12}
                          md={12}
                          sm={12}
                          className="inner-sec-text first-sec-mon"
                        >
                          <Col md={7} className="">
                            <FormItem
                              name={`CoAppEmail${index}`}
                              label="Email Address"
                              colon={false}
                              rules={[
                                {
                                  required: false,
                                  message: "Please Enter Email Address",
                                },
                                {
                                  pattern:
                                    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                                  message: "Please Enter a valid Email!",
                                },
                              ]}
                            >
                              <TextInput
                                onInput={(e) => {
                                  if (e.target.value.trim() == "") {
                                    e.target.value = e.target.value.trim();
                                  }

                                  if (e.target.value.trim() !== "") {
                                    e.target.value = e.target.value.trim();
                                  }
                                }}
                                name={`emailAddress${index}`}
                                value={applicant.emailAddress}
                                onChange={(e) =>
                                  onChangeCoApp(e, "emailAddress", index)
                                }
                                type="text"
                                maxLength={75}
                              />
                            </FormItem>
                          </Col>

                          <Col md={5} className="">
                            <FormItem
                              name={`CoAppMobileNo${index}`}
                              label="Mobile No"
                              colon={false}
                              rules={[
                                {
                                  required: applicant?.required,
                                  message: "Please Enter mobile no",
                                },
                                ({ getFieldValue }) => ({
                                  validator(_, value) {
                                    if (
                                      !value ||
                                      /^[6-9][0-9]{9}$/.test(value)
                                    ) {
                                      return Promise.resolve();
                                    }
                                    return Promise.reject(
                                      "Invalid mobile number"
                                    );
                                  },
                                }),
                              ]}
                            >
                              <TextInput
                                name={`mobileNo${index}`}
                                type="text"
                                maxLength={10}
                                onInput={(e) => {
                                  if (e.target.value.trim() == "") {
                                    e.target.value = e.target.value.trim();
                                  }

                                  if (e.target.value.trim() !== "") {
                                    e.target.value = new RegExp(
                                      "^[0-9-+]*$"
                                    ).test(e.target.value)
                                      ? e.target.value?.trimStart()
                                      : e.target.value
                                          ?.trimStart()
                                          ?.substring(
                                            0,
                                            e.target.value.length - 1
                                          );
                                  }
                                }}
                                value={applicant.mobileNo}
                                onKeyPress={handleMobileNumberKeyPress}
                                onChange={(e) =>
                                  onChangeCoApp(e, "mobileNo", index)
                                }
                              />
                            </FormItem>
                          </Col>
                        </Col>
                      </Row>
                      <Row>
                        <Col
                          lg={12}
                          xs={12}
                          md={12}
                          sm={12}
                          className="inner-sec-text first-sec-mon"
                        >
                          <Col md={7} className="coApprelation">
                            <FormItem
                              name={`CoAppRelation${index}`}
                              label="Relationship With Student"
                              colon={false}
                              rules={[
                                {
                                  required: true,
                                  message: "Please  select one option",
                                },
                              ]}
                            >
                              <UiDropDown
                                data={reloptions}
                                onChange={(value) =>
                                  handleChangeRelationData(value, index)
                                }
                              />
                            </FormItem>
                          </Col>
                        </Col>
                      </Row>
                      <br></br>
                      <br></br>
                    </>
                  );
                })}

              </> */}
              <br></br>
              <Row>
                <Col
                  lg={12}
                  xs={12}
                  md={12}
                  sm={12}
                  className="inner-sec-text first-sec-mon"
                >
                  <Col md={5}></Col>

                  <Col md={3}>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      {/* <Checkbox
                        onClick={onChangeDoc}
                        className="addleadcheckbox"
                      />
                      <h6>Upload documents</h6> */}
                    </div>
                  </Col>
                  <Col
                    className="AddCoAppBtn"
                    style={{ marginRight: "30px" }}
                    md={3}
                  >
                    {/* <UiButton
                      disabled={coApplicants.length == 5}
                      type="button"
                      title="Add coapplicant"
                      onClick={addCoApplicant}
                    /> */}
                  </Col>
                  <Col md={3}>
                    {openPopover ? (
                      <Popover
                        content={
                          <div style={{ display: "flex", gap: "10px" }}>
                            <Button
                              disabled={btnDisable}
                              style={{
                                backgroundColor: "#1b8593",
                                borderColor: "#1b8593",
                              }}
                              type="primary"
                              onClick={handleYesClick}
                            >
                              Yes
                            </Button>
                            <Button
                              style={{
                                borderColor: "#1b8593",
                                color: "#1b8593",
                              }}
                              onClick={handleNoClick}
                            >
                              No
                            </Button>
                          </div>
                        }
                        title={popUpLabel}
                        trigger="click"
                        open={openPopover}
                        onOpenChange={handleOpenChange}
                      >
                        <UiButton
                          disabled={btnDisable}
                          type="submit"
                          title={"SAVE & CREATE LEAD"}
                          onClick={handlenewEooro}
                        />
                      </Popover>
                    ) : (
                      <UiButton
                        disabled={btnDisable}
                        type="submit"
                        title={"SAVE & CREATE LEAD"}
                        onClick={handlenewEooro}
                      />
                    )}
                  </Col>
                </Col>
              </Row>

              {/* <Row>
                  <Col md={6}>
                    <FormItem
                      name="contactCenterQualification"
                      label="Contact Center Qualification"
                      colon={false}
                      rules={[
                        {
                          required: false,
                          message: "Please Select Contact Center Qualification",
                        },
                      ]}
                    >
                      <Radio.Group
                        onChange={handleChangeQualification}
                        value={contactRadio}
                        defaultValue={false}
                      >
                        <Radio value={true}>Yes</Radio>
                        <Radio value={false}>No</Radio>
                      </Radio.Group>
                    </FormItem>
                  </Col>
                </Row> */}
              <br></br>
            </div>
          </div>
        </div>
      </Form>
    </div>
  );
};
const mapDispatchToProps = (dispatch) => {
  return {
    getAddLeadMasterList: (data) => dispatch(getAddLeadMasterList(data)),
    searchUniversityDetails: (user) => dispatch(searchUniversityDetails(user)),
    searchCollegeDetails: (user) => dispatch(searchCollegeDetails(user)),
    searchCourseDetail: (user) => dispatch(searchCourseDetail(user)),
    getPincodeList: (data) => dispatch(getPincodeOnSearch(data)),
    getBranchLocationByArea: (data) => dispatch(getBranchLocationByArea(data)),
    getBranchLocationByPincode: (data) =>
      dispatch(getBranchLocationByPincode(data)),
    getSideBarBranch: (data) => dispatch(getSideBarBranch(data)),
    searchPartnerNameDetail: (data) => dispatch(searchPartnerNameDetail(data)),
    getSideBarBranch: (data) => dispatch(getSideBarBranch(data)),
    saveAddLeadDetails: (data) => dispatch(saveAddLeadDetails(data)),
    getRelationshipDetails: (data) => dispatch(getRelationshipDetails(data)),
  };
};

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    state: state && state.auth,
    partnerSidebar: state && state.partnerSidebar,
    access_token: state && state.auth && state.auth.idToken,
    LogoutFlag: state.Logout,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddLead);
